module.exports = __webpack_public_path__ + "static/media/start_menu_bg.11bb54e4.jpg";